var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 17.367,
    viewBox: "0 0 18.5 17.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".badge{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "badge",
    x2: 4,
    transform: "translate(10 9.133)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "badge",
    x2: 4,
    transform: "translate(10 12.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "badge",
    d: "M5.033,3.5h-3.4A1.133,1.133,0,0,0,.5,4.633v10.2a1.133,1.133,0,0,0,1.133,1.133H16.367A1.133,1.133,0,0,0,17.5,14.833V4.633A1.133,1.133,0,0,0,16.367,3.5h-3.4",
    transform: "translate(-0.5 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "badge",
    width: 4,
    height: 3,
    transform: "translate(3 9.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "badge",
    d: "M8.2.5h0A1.7,1.7,0,0,1,9.9,2.2V6.167H6.5V2.2A1.7,1.7,0,0,1,8.2.5Z",
    transform: "translate(0.3 -0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.ffb7f27048c0185fa23c5f13ab174ed4.svg";
export { ForwardRef as ReactComponent };